import { axios } from "lib/axios";
import { ReasonsResponse, SiteOptions, Sites } from "../types";
import { AxiosError } from "axios";

export const getSites = (): Promise<Sites> => {
  return axios.get("/site/sites");
};

export const getSiteOptions = (): Promise<SiteOptions> => {
  return axios.get("/site/options");
};

export const fetchReasonsForLeaving = (): Promise<ReasonsResponse> => {
  return axios.get("/leaver/leave_reasons");
};


export const startLeaverProcess = async (
  data: any
): Promise<any> => {
  try {
    const response = (await axios.post(
      "/leaver/leave_request",
      data
    )) as any;
    return response;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error.response);
    }
    throw error;
  }
};